import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import App from './App.vue'
import store from './store'
import router from './router'
import './permission'

import Router from 'vue-router'
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

/** 关闭当前顶部标签并返回上一页（二级页点返回时用） */
Vue.prototype.$closePage = function (fallback) {
  const view = this.$route
  return this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
    if (window.history.length > 1) {
      this.$router.back()
      return
    }
    if (fallback) {
      this.$router.push(fallback)
      return
    }
    const latest = (visitedViews || []).slice(-1)[0]
    this.$router.push(latest ? (latest.fullPath || latest.path) : '/')
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
